document.addEventListener("DOMContentLoaded", function () {
    // Check if any section partner logos exist on the page
    const containers = document.querySelectorAll(".section-partner-logos-block__logos");
    
    // If no containers found, exit early
    if (containers.length === 0) {
        return;
    }
    
    // Add the global styles only once
    const globalStyle = document.createElement("style");
    globalStyle.innerHTML = `
        @keyframes scroll-logos {
            0% {
                transform: translateX(0);
            }
            100% {
                transform: translateX(calc(-50%));
            }
        }

        .section-partner-logos-block__logos {
            display: flex;
            overflow: hidden;
            position: relative;
            -webkit-mask-image: linear-gradient(90deg, #0000, #000 10% 90%, #0000);
            mask-image: linear-gradient(90deg, #0000, #000 10% 90%, #0000);
            -webkit-mask-source-type: alpha;
            mask-mode: alpha;
        }

        .logos-inner-wrapper {
            display: flex;
            width: max-content;
        }

        .section-partner-logos-block__logo {
            flex-shrink: 0;
        }
    `;
    document.head.appendChild(globalStyle);
    
    // Process each container
    containers.forEach((container, index) => {
        // Skip if container has no children
        if (container.children.length === 0) {
            return;
        }
        
        const logos = Array.from(container.children);
        
        // Create a unique inner wrapper for this container
        const innerWrapper = document.createElement("div");
        innerWrapper.classList.add("logos-inner-wrapper");
        
        // Add a unique class to this inner wrapper for targeted animation
        const uniqueClass = `logos-inner-wrapper-${index}`;
        innerWrapper.classList.add(uniqueClass);
        
        // Duplicate logos to ensure smooth scrolling
        for (let i = 0; i < 2; i++) {
            logos.forEach(logo => {
                innerWrapper.appendChild(logo.cloneNode(true));
            });
        }
        
        // Clear the container and add the inner wrapper
        container.innerHTML = "";
        container.appendChild(innerWrapper);
        
        // Add instance-specific animation style
        const instanceStyle = document.createElement("style");
        instanceStyle.innerHTML = `
            .${uniqueClass} {
                animation: scroll-logos 50s linear infinite;
            }
        `;
        document.head.appendChild(instanceStyle);
    });
});